<template>
  <div>
    <div class="content-bottom-padded">
      <el-alert type="info" title="操作说明" show-icon>
        <div> 多规格说明：默认列表中只显示多规格的默认值，如果想要显示全部规格列表，请选择【多规格分开展示】后搜索，该状态下不可编辑商品</div>
      </el-alert>

    </div>
    <div v-if="$route.path.indexOf('_editor') === -1">
      <el-row :gutter="20">
        <el-col :md="10" :lg="7">
          <el-input placeholder="商品名称" size="small" v-model="params.keywords">
            <el-button slot="append" icon="el-icon-search" @click="goodsSearch"></el-button>
          </el-input>
        </el-col>
        <el-col :md="10" :lg="7">
          <el-input placeholder="商品编号" size="small" v-model="params.item_bn">
            <el-button slot="append" icon="el-icon-search" @click="goodsSearch"></el-button>
          </el-input>
        </el-col>
        <el-col :span="5">
          <el-select v-model="templates_id" size="small" @change="handleChangeTemplates" placeholder="运费模板" clearable
                     style="width: 100%;">
            <el-option v-for="item in templatesList" :key="item.template_id" :label="item.name"
                       :value="item.template_id"></el-option>
          </el-select>
        </el-col>
        <el-col :span="3">
          <el-cascader
              size="small"
              placeholder="商品产地"
              :options="regions"
              v-model='select_regions_value'
              clearable
              @change="searchAction">
          </el-cascader>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :md="10" :lg="7">
          <el-select size="small" v-model="params.approve_status" clearable placeholder="请选择状态" @change="goodsSearch">
            <el-option v-if="login_type != 'distributor'" v-for="item in statusOption" :key="item.value"
                       :label="item.title" size="mini" :value="item.value"></el-option>
            <el-option v-if="login_type == 'distributor'" v-for="item in shopStatusOption" :key="item.value"
                       :label="item.title" size="mini" :value="item.value"></el-option>
          </el-select>
        </el-col>
        <el-col :span="3">
          <el-cascader
              size="small"
              placeholder="选择品牌"
              filterable
              :options="goodsBranchList"
              :props="{value:'attribute_id', label: 'attribute_name'}"
              v-model='select_branch_value'
              clearable
              @change="searchAction">
          </el-cascader>
        </el-col>
        <el-col :span="3">
          <el-cascader
              size="small"
              filterable
              placeholder="选择分类"
              :options="categoryList"
              :props="{value:'category_id', checkStrictly: true}"
              v-model='select_category_value'
              clearable
              @change="searchAction">
          </el-cascader>
        </el-col>
        <el-col :span="3">
          <el-cascader
              size="small"
              filterable
              placeholder="选择标签"
              :options="tag.list"
              :props="{value:'tag_id', label: 'tag_name'}"
              v-model='select_tags_value'
              clearable
              @change="searchAction">
          </el-cascader>
        </el-col>
        <el-col :span="3">
          <el-select size="small" v-model="params.special_type" clearable placeholder="商品类型" @change="searchAction">
            <el-option
                placeholder="商品类型"
                v-for="item in special_type_list"
                :key="item.value"
                :label="item.name"
                :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="3">
          <el-select size="small" v-model="params.is_sku" clearable placeholder="多规格展示" @change="searchAction">
            <el-option
                placeholder="商品类型"
                v-for="item in sku_list"
                :key="item.value"
                :label="item.name"
                :value="item.value">
            </el-option>
          </el-select>
        </el-col>


      </el-row>
      <el-row>

        <el-col :md="10" :lg="12">
          <el-input :rows="1" placeholder="多商品货号，多个货号使用回车换行" type='textarea' v-model="search_item_bns" clearable
                    size="mini">
          </el-input>
        </el-col>
        <el-col :span="3">
          <el-select size="small" v-model="params.items_attr" clearable placeholder="商品属性">
            <el-option
                placeholder="商品属性"
                v-for="(item,index) in itemsAttrArr"
                :key="index"
                :label="item"
                :value="index">
            </el-option>
          </el-select>
        </el-col>

        <el-col :span="3">
          <el-select size="small" v-model="params.items_scope" clearable placeholder="商品属性范围">
            <el-option
                placeholder="商品属性范围"
                v-for="(item,index) in itemsScopeArr"
                :key="index"
                :label="item"
                :value="index">
            </el-option>
          </el-select>
        </el-col>
        <el-col :md="10" :lg="7">
          <el-select size="small" v-model="params.vip_flag" clearable placeholder="vip商品" @change="goodsSearch">
            <el-option label="vip商品" value="1"></el-option>
            <el-option label="非vip商品" value="0"></el-option>
          </el-select>
        </el-col>
        <el-col :md="10" :lg="12">
          <el-button size="mini" type="primary" icon="plus" @click="searchAction">确定</el-button>
        </el-col>
      </el-row>
      <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
        <el-tab-pane v-for="(item, index) in tabList" :key="index" :label="item.name" :name="item.activeName">
          <div v-if="activeName == 'second'" style="margin-bottom: 15px; width:280px;">
            <el-input v-model="warning_store" value="warning_store">
              <template slot="prepend">预警数量</template>
              <el-button slot="append" @click="setWarningStore">保存</el-button>
            </el-input>
          </div>
          <el-table :data="ItemsList" style="width: 100%" @selection-change="handleSelectionChange"
                    :height="wheight-330" v-loading="loading">
            <el-table-column type="selection" align="center" label="全选"></el-table-column>
            <el-table-column label="操作" width="100" fixed>
              <template slot-scope="scope">
                <el-button type="text" @click="editItemsAction(scope.$index, scope.row, false)" class="btn-gap">编辑
                </el-button>
                <!-- <el-popover
                    placement="right"
                    width="450"
                    trigger="hover">
                  <div class="operating-icons">
                    <el-button type="text" @click="deleteItemsAction(scope.$index, scope.row)" class="btn-gap">删除
                    </el-button>
                    <el-button type="text" @click="editItemsAction(scope.$index, scope.row, true)" class="btn-gap">
                      添加相似
                    </el-button>
                    <el-button type="text" @click="handlePrice(scope.row)" class="btn-gap">设置价格</el-button>
                    <el-button type="text" @click="tagUpdate(scope.row)" class="btn-gap">标签</el-button>
                    <el-button type="text" @click="updateItemsStore(scope.row)" class="btn-gap">更改库存</el-button>
                    <el-button class="copy-btn"
                               type="text"
                               v-clipboard:copy="scope.row.link"
                               v-clipboard:success="onCopy">
                      <input class="copy-link" type="text" v-model="scope.row.link">复制链接
                    </el-button>
                    <el-button type="text" v-if="scope.row.approve_status == 'onsale'"
                               @click="updateItemStatus(scope.row)" class="btn-gap">下架
                    </el-button>
                    <el-button type="text" v-if="scope.row.approve_status == 'instock'"
                               @click="updateItemStatus(scope.row)" class="btn-gap">上架
                    </el-button>
                    <el-button type="text" @click="handleBatchStore(scope.row)" class="btn-gap">商品批量同步到店铺</el-button>
                    <el-button type="text" @click="yibeiSync(scope.row)" class="btn-gap">同步到怡贝</el-button>
                    <el-button type="text" @click="handleVipDiscount(scope.row)" class="btn-gap">设置尊享会员折扣</el-button>
                  </div>
                  <el-button type="text" slot="reference"><i class="iconfont icon-angle-double-right"></i></el-button>
                </el-popover> -->
              </template>
            </el-table-column>
            <el-table-column prop="goods_id" label="商品ID" width="120">
              <template slot-scope="scope">
                货号:{{ scope.row.item_bn }}<br/>
                默认ID:{{ scope.row.goods_id }}<br/>
                当前ID:{{ scope.row.item_id }}
              </template>
            </el-table-column>
            <!-- <el-table-column prop="item_bn" label="商品货号" width="100">
              <template slot-scope="scope">
                {{ scope.row.item_bn }}
              </template>
            </el-table-column> -->
            <el-table-column prop="itemName" label="商品名称" width="180">
              <template slot-scope="scope">
                {{ scope.row.item_name }}
                <el-tag type="danger" size="mini" v-if="scope.row.special_type == 'drug'">处方药</el-tag>
                <el-tag type="danger" size="mini" v-if="scope.row.is_settle_in == true">服务商品</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="图片">
              <template slot-scope="scope">
                <el-popover
                    placement="top"
                    width="240"
                    trigger="click"
                    v-model="visible">
                    <img :src="newimageurl" style="width:180%;height:180%;" >
                    <el-button type="text" slot="reference">
                      <ul class="goodspic-wrap">
                        <li v-for="(item, index) in scope.row.pics" :key='index' class="goodspic">
                          <img :src="wximageurl + item" style="width:95%;height:95%;"  @click="showtitle(wximageurl + item)" >
                        </li>
                      </ul>
                    </el-button>
                </el-popover>
              </template>
            </el-table-column>
          </el-table>
          <div class="content-center content-top-padded">
            <el-pagination
                background
                layout="total, sizes, prev, pager, next"
                @current-change="handleCurrentChange"
                @size-change="handleSizeChange"
                :current-page.sync="params.page"
                :page-sizes="[10,20,50,100,200]"
                :total="total_count"
                :page-size="params.pageSize">
            </el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
      <!-- 选择运费模板-开始 -->
      <el-dialog
          title="更改运费模板"
          :visible.sync="addTemplatesdialogVisible"
          width="30%">
        <el-select v-model="templates_new_id" placeholder="运费模板" style="width: 100%;">
          <el-option v-for="item in templatesList" :key="item.template_id" :label="item.name"
                     :value="item.template_id"></el-option>
        </el-select>
        <span slot="footer" class="dialog-footer">
          <el-button @click="addTemplatesdialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="changeTemplates">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 选择运费模板-结束 -->
      <!-- 选择商品分类-开始 -->
      <el-dialog
          title="更改商品分类"
          :visible.sync="addCategorydialogVisible"
          width="30%">
        <treeselect
            :options="categoryList"
            :multiple="true"
            :show-count="true"
            :disable-branch-nodes="true"
            v-model="category_id"
        >
        </treeselect>
        <span slot="footer" class="dialog-footer">
          <el-button @click="addCategorydialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="changeCategory">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog title="为商品打标签" class="right-dialog" :visible.sync="tag.dialog"
                 :before-close="handleCancelLabelsDialog">
        <div class="tag-users view-flex view-flex-middle">
          <i class="iconfont icon-user-circle1"></i>
          <div class="view-flex-item">
            <span v-for="item in tag.editItem"> {{ item }}，</span>
          </div>
        </div>
        <div class="selected-tags view-flex">
          <div class="label">已选中标签：</div>
          <div class="view-flex-item">
            <el-tag :key="index" v-for="(tag, index) in tag.currentTags" closable size="small"
                    :disable-transitions="false" @close="tagRemove(index)">
              {{ tag.tag_name }}
            </el-tag>
          </div>
        </div>
        <div>
          <el-tag class="tag-item" :key="index" v-for="(tag, index) in tag.tags" size="medium" color="#ffffff"
                  :disable-transitions="false" @click.native="tagAdd(tag, index)">
            {{ tag.tag_name }}
          </el-tag>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="tag.dialog = false">取 消</el-button>
          <el-button type="primary" @click="submitItemTag">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog title="商品下标签" class="right-dialog" :visible.sync="tag.dialogdel"
                 :before-close="handleCancelLabelsDialogdel">

        <div class="selected-tags view-flex">
          <div class="label">选择标签：</div>
          <div class="view-flex-item">
            <el-tag :key="index" v-for="(tag, index) in deltaglist" closable size="small" :disable-transitions="false"
                    @close="tagdelone(index)">
              {{ tag.tag_name }}
            </el-tag>
          </div>

        </div>
        <div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="tag.dialogdel = false">取 消</el-button>
          <el-button type="primary" @click="submitItemTagdel">确 定</el-button>
        </span>
      </el-dialog>
      <SideBar :visible.sync="show_rebate_sideBar" title="商品分销配置" width="60">
        <slot>
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span v-if="popularizeSetting.popularize_ratio.type == 'profit'">
                <el-alert title="返佣计算类型: 【按利润分佣】"
                          description="计算方式：商品利润 ×  百分比，其中商品利润为【支付金额-运费-商品成本价】，如果设置的返佣为固定金额，则不会按利润返佣，返佣金额就是设置的固定金额。如果不填则使用通用配置返佣"
                          type="info" close-text=" " class="alert-text" show-icon>
                </el-alert>
              </span>
              <span v-else>
                <el-alert title="返佣计算类型: 【按订单金额分佣】"
                          description="计算方式： 订单金额 × 百分比，其中订单金额为【支付金额-运费】，如果设置的返佣为固定金额，则不会按订单金额分佣，返佣金额就是设置的固定金额。如果不填则使用通用配置返佣"
                          type="info" close-text=" " class="alert-text" show-icon>
                </el-alert>
              </span>
            </div>
            商品名称：{{ current.item_name }}
            <el-table :data="rebateSpecItems" v-loading="skuLoading">
              <el-table-column label="规格" prop="item_spec_desc" min-width="120">
                <template slot-scope="scope"><span v-if="scope.row.item_spec_desc">{{ scope.row.item_spec_desc }}</span><span
                    v-else>单规格</span></template>
              </el-table-column>
              <el-table-column label="商品价格" min-width="80">
                <template slot-scope="scope"> ¥{{ scope.row.price / 100 }}</template>
              </el-table-column>
              <el-table-column label="成本价" min-width="80">
                <template slot-scope="scope"> ¥{{ scope.row.cost_price / 100 }}</template>
              </el-table-column>
              <el-table-column label="类型" width="160">
                <template slot-scope="scope">
                  <el-switch v-model="scope.row.rebate_conf.type" active-value="money" inactive-value="ratio"
                             active-text="金额" inactive-text="比例"></el-switch>
                </template>
              </el-table-column>
              <el-table-column v-for="(item,key) in popularizeSetting.popularize_ratio.profit" :key="key"
                               :label="item.name" min-width="110">
                <template slot-scope="scope">
                  <el-input v-if="scope.row.rebate_conf.type == 'money'" type="number"
                            v-model="scope.row.rebate_conf.value[key]" size="mini"
                            suffix-icon="iconfont icon-yen-sign"></el-input>
                  <el-input v-else v-model="scope.row.rebate_conf.value[key]" size="mini" type="number"
                            suffix-icon="iconfont icon-percent"></el-input>
                </template>
              </el-table-column>
            </el-table>
          </el-card>
        </slot>
        <div slot="footer">
          <el-button type="primary" @click="saveRebateConf" :loading="submitLoading">保存</el-button>
        </div>
      </SideBar>
      <SideBar :visible.sync="show_sideBar" title="设置价格" width="60">
        <div class="content-bottom-padded">
          <el-alert type="info" title="编辑提示" show-icon>
            <div>
              如果填写店铺id则以店铺id为准
            </div>
          </el-alert>
        </div>
        <el-form label-position="left">
          <el-form-item label="所属大区：">
            <el-row :gutter="10">
              <el-col :span="10">
                <!--<el-select v-model="office_area_name"  placeholder="所属大区" @change="handleOfficeChange">-->
                <!--<el-option   :key="office_area_all.value" :label="office_area_all.name"   :value="office_area_all.name" >-->
                <!--</el-option>-->
                <!--<el-option  v-for="item in office_area" :key="item.area_id" :label="item.name" :value="item.name" >-->
                <!--</el-option>-->
                <!--<div v-show="false">-->
                <!--<el-col ><el-input v-model="office_area_id" placeholder=""></el-input></el-col>-->
                <!--</div>-->
                <!--</el-select>-->
                <el-cascader placeholder="所属大区" @change="handleOfficeChange"
                             :options="new_office_area"
                             :props="{ checkStrictly: true }"
                             clearable>
                </el-cascader>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="店铺id(多个店铺用英文逗号隔开)： ">
            <el-row :gutter="10">
              <el-col :span="10">
                <el-input type="textarea" v-model="districtId" placeholder="请填写店铺id"></el-input>
              </el-col>
            </el-row>
          </el-form-item>
        </el-form>

        <el-table :data="specItems" v-loading="skuLoading" height="25%">
          <el-table-column label="规格" prop="item_spec_desc" min-width="120">
          </el-table-column>
          <el-table-column label="商品价格" width="100">
            <template slot-scope="scope">
              <div v-if="scope.row.item_id !== currentId">
                ¥{{ scope.row.price }}
                <i class="el-input__icon el-icon-edit" @click="editPrice(scope.row.item_id, scope.row.price)"></i>
              </div>
              <el-input v-else v-model="currentPrice" @blur="handleBlur(scope.$index,scope)" size="mini"
                        :ref="'input_' + scope.row.item_id"></el-input>
            </template>
          </el-table-column>
          <!--<el-table-column label="会员">-->
          <!--<el-table-column v-for="(item, index) in grade" :key="index" :label="item.grade_name">-->
          <!--<template slot-scope="scope">-->
          <!--<el-input v-model="scope.row.grade[index].mprice" size="mini" type="number"></el-input>-->
          <!--</template>-->
          <!--</el-table-column>-->
          <!--</el-table-column>-->
          <el-table-column label="修改后价格">
            <template slot-scope="scope">
              <el-input size="mini" v-model="currentPriceChange" :ref="'input_' + scope.row.item_id"></el-input>
            </template>
          </el-table-column>

          <el-table-column label="价格同步至指定门店">
            <template slot-scope="scope">
              <el-button type="primary" @click="syncPrice(scope.row.item_id)" :loading="batchsubmitLoading">同步商品价格
              </el-button>
              <!--<el-button type="primary" @click="confirmSyncPrice(scope.row.item_id, scope.row.price)" :loading="batchsubmitLoading">同步商品价格</el-button>-->
            </template>
          </el-table-column>

        </el-table>
        <el-form label-position="left">
          <el-form-item label="">
            <el-table :data="specItems" v-loading="skuLoading">
              <el-table-column label="以下店铺价格和商品价格不同">
                <template slot-scope="scope">
                  <el-collapse>
                    <el-collapse-item title="" name="1">
                      <div v-for="(distritors_prics,key,value) in scope.row.distributors_prices_arr">
                        店铺id {{ key.split('_')[1] }} 价格:￥{{ distritors_prics / 100 }}
                      </div>
                    </el-collapse-item>
                  </el-collapse>
                </template>
              </el-table-column>

            </el-table>
          </el-form-item>
        </el-form>
        <!--<div slot="footer"><el-button type="primary" @click="savePrice" :loading="submitLoading">保存</el-button></div>-->
      </SideBar>
      <!-- 选择商品分类-结束 -->
      <SideBar :visible.sync="show_itemStore" title="设置商品库存" width="60">
        <slot>
          <el-table :data="storeItemsList" v-loading="skuLoading" height="100%">
            <el-table-column label="规格" prop="item_spec_desc" min-width="120">
            </el-table-column>
            <el-table-column label="库存">
              <template slot-scope="scope">
                <el-input v-model="scope.row.store" size="mini" type="number"></el-input>
              </template>
            </el-table-column>
          </el-table>
        </slot>
        <div slot="footer">
          <el-button type="primary" @click="saveItemsStore" :loading="submitLoading">保存</el-button>
        </div>
      </SideBar>
      <!-- 商品批量同步到店铺  -->
      <SideBar :visible.sync="show_batchStore" title="商品批量同步到店铺" width="60">
        <div class="content-bottom-padded">
          <el-alert type="info" title="编辑提示" show-icon>
            <div>
              如果输入店铺id(英克id)则店铺类型和区域类型无效。<br>
              店铺类型和店铺区域不能同时选择<br>
              店铺区域属于怡康自营门店和第三方门店无关
            </div>
          </el-alert>
        </div>
        <el-form label-position="left">
          <el-form-item label="商品id：">
            <el-row :gutter="10">
              <el-col :span="10">
                {{ current }}
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="商品价格：">
            <el-row :gutter="10">
              <el-col :span="10">
                ¥{{ current_goods_price }}
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="店铺类型： ">
            <el-row :gutter="10">
              <el-col :span="10">
                <el-select v-model="params.shop_type_id" placeholder="选择店铺类型" style="width: 100%;">
                  <el-option
                      v-for="shop in shop_type_list_default"
                      :key="shop.shop_type_id"
                      :label="shop.shop_type_name"
                      :value="shop.shop_type_id">
                  </el-option>
                  <el-option
                      v-for="shop in shop_type_list"
                      :key="shop.shop_type_id"
                      :label="shop.shop_type_name"
                      :value="shop.shop_type_id">
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="区域分类">
            <el-row :gutter="10">
              <el-col :span="10">
                <el-cascader placeholder="所属大区" @change="handleOfficeChange"
                             :options="new_office_area"
                             :props="{ checkStrictly: true }"
                             clearable>
                </el-cascader>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="库存： " v-if="show_item_stock">
            <el-row :gutter="10">
              <el-col :span="10">
                <el-input-number :min="0" v-model="stock" :maxlength="30" placeholder="请填写库存">
                  <i slot="suffix" class="el-input__icon el-icon-edit"></i>
                </el-input-number>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="上下架操作： ">
            <el-row :gutter="10">
              <el-col :span="10">
                <el-switch v-model="is_open"></el-switch>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="店铺英克ID(多个ID用英文逗号隔开)： ">
            <el-row :gutter="10">
              <el-col :span="10">
                <el-input type="textarea" v-model="districtId" placeholder="请填写店铺id"></el-input>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item style="margin:0 50%">
            <el-row :gutter="10">
              <el-col :span="10">
                <el-button type="primary" @click="saveSynsc" :loading="submitLoading">保存</el-button>
              </el-col>
            </el-row>
          </el-form-item>
        </el-form>
      </SideBar>
      <SideBar :visible.sync="show_batch_vipdiscount" title="批量设置尊享会员折扣" width="60">
        <el-form label-position="left">
          <el-form-item label="商品货号：">
            <el-row :gutter="20">
              <el-col :span="20">
                {{ this.item_bn }}
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="商品折扣：">
            <el-row :gutter="10">
              <el-col :span="10">
                <el-input-number :min="0" :max="100" :step="1" :precision="0" v-model="current_item_vip_discount" placeholder="商品折扣">
                  <i slot="suffix" class="el-input__icon el-icon-edit"></i>
                </el-input-number>
                <br>
                <small>折扣取值范围在 0 - 100 之间，按百分比计算。（如：输入 88 就等价于 8.8 折）</small>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="注意：">
            <el-row :gutter="20">
              <el-col :span="20">
                <span style="color: red; font-size: 16px;">当前共对 {{ this.item_bn.length }} 个商品进行会员折扣设置，请仔细核对后再点击保存！修改成功后请仔细核查前后端页面所展示的会员价格！！！</span>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item style="margin:0 50%">
            <el-row :gutter="10">
              <el-col :span="10">
                <el-button type="primary" @click="batchSaveVipDiscount" element-loading-text="提交中，请稍后" :loading="submitLoading">保存</el-button>
              </el-col>
            </el-row>
          </el-form-item>
        </el-form>
      </SideBar>
      <SideBar :visible.sync="show_vipdiscount" title="设置尊享会员折扣" width="60">
        <el-form label-position="left">
          <el-form-item label="商品ID：">
            <el-row :gutter="10">
              <el-col :span="10">
                {{ current_item_id }}
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="商品货号：">
            <el-row :gutter="10">
              <el-col :span="10">
                {{ current_item_bn }}
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="商品价格：">
            <el-row :gutter="10">
              <el-col :span="10">
                ¥{{ current_goods_price }}
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="商品折扣：">
            <el-row :gutter="10">
              <el-col :span="10">
                <el-input-number :min="0" :max="100" :step="1" :precision="0" v-model="current_item_vip_discount" placeholder="商品折扣">
                  <i slot="suffix" class="el-input__icon el-icon-edit"></i>
                </el-input-number>
                <br>
                <small>折扣取值范围在 0 - 100 之间，按百分比计算。（如：输入 88 就等价于 8.8 折）</small>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="会员折后价格：">
            <el-row :gutter="10">
              <el-col :span="10">
                ¥{{ current_goods_price * current_item_vip_discount / 100 }}
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item style="margin:0 50%">
            <el-row :gutter="10">
              <el-col :span="10">
                <el-button type="primary" @click="saveVipDiscount" :loading="submitLoading">保存</el-button>
              </el-col>
            </el-row>
          </el-form-item>
        </el-form>
      </SideBar>
      <el-dialog
          title="批量修改库存"
          :visible.sync="storeUpdate"
          width="30%">
        统一库存：
        <el-input v-model="itemstore" size="mini" type="number"></el-input>
        <span slot="footer" class="dialog-footer">
          <el-button @click="storeUpdate = false">取 消</el-button>
          <el-button type="primary" @click="saveItemsStore">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog
          title="批量修改价格"
          :visible.sync="batchGoodsPricesView"
          width="60%">
        <el-row :gutter="10">
          <el-col :span="10">
            正在编辑{{ goodsNum }}条数据。
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="20">
            小技巧:
            <span class="price-content">
                    直接修改：对所选商品的某个价格进行统一修改。</span>
            <span class="price-content">
                    公式调价：将所选商品的某个价格修改为在另一个价格的基础上加减乘一个数字。</span>
            <span class="price-content-ts">
                    提示：公式调价中，等号两边列表中的会员价表示的意义不同，</span>
            <span class="price-content">
                    等号前边是最终的结果(公式计算的最终结果，直接保存为会员价格)，</span>
            <span class="price-content">
                    等号后边是计算公式中的参数（他的值为原销售价*会员等级的折扣率）。
                  </span>
          </el-col>

        </el-row>
        <el-radio-group v-model="price_mode" @change="changeHandler">
          <el-row :gutter="10" class='batch_price'>
            <el-col :span="40">
              <el-radio label="direct">直接修改</el-radio>
              <el-select v-model="price_type_direct_sel" clearable placeholder="价格类型" class="pri-sel"
                         @change="price_type_direct_act">
                <el-option
                    placeholder="价格类型"
                    v-for="item in price_type_direct"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value">
                </el-option>
              </el-select>
              <el-tag class="pri-tag">=</el-tag>
              <el-input v-model="newPrice" class='pri-inp' placeholder="价格(分)" size="mini" type="text"></el-input>
            </el-col>
          </el-row>
          <el-row :gutter="10" class='batch_price'>
            <el-col :span="60">
              <el-radio label="formula">公式修改</el-radio>
              <el-select v-model="price_type_formula_sel" clearable placeholder="价格类型" class="pri-sel"
                         @change="price_type_formula_act">
                <el-option
                    placeholder="价格类型"
                    v-for="item in price_type_formula"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value">
                </el-option>
              </el-select>
              <el-tag class="pri-tag">=</el-tag>
              <el-select v-model="price_type_main_sel" clearable placeholder="价格类型" class="pri-sel"
                         @change="price_type_main_act">
                <el-option
                    placeholder="价格类型"
                    v-for="item in price_type_main"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value">
                </el-option>
              </el-select>
              <el-select v-model="algorithmVal" clearable placeholder="价格类型" class="pri-sel" @change="algorithmVal_act">
                <el-option
                    placeholder="价格类型"
                    v-for="item in algorithm"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value">
                </el-option>
              </el-select>
              <el-input v-model="newPrice2" class='pri-inp' placeholder="加减时（分）" size="mini" type="text"></el-input>
            </el-col>
          </el-row>
        </el-radio-group>
        <span slot="footer" class="dialog-footer">
            <el-button @click="batchGoodsPricesView = false">取 消</el-button>
            <el-button type="primary" @click="savebatchGoodsPrices">确 定</el-button>
        </span>
      </el-dialog>

    </div>
    <router-view></router-view>
  </div>
</template>
<script>
// import office_area from '../../../../common/office_area.json'
import {mapGetters} from 'vuex'
import {getPopularizeSetting} from '@/api/promotions'
// import the component
import Treeselect from '@riophae/vue-treeselect'
import SideBar from '@/components/element/sideBar'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import {Message} from 'element-ui'
import {getShippingTemplatesList} from '@/api/shipping'
import {getDefaultCurrency} from '@/api/company'
import district from '@/common/district.json'
import {getShopTypes, addStore} from '@/api/marketing'
import {getAreaManageList} from "@/api/areamanage";
import {
  getItemsList,
  setItemsTemplate,
  setItemsCategory,
  deleteItems,
  getItemWarningStore,
  getCategory,
  setItemsSort,
  updateGoodsInfo,
  getGoodsPrice,
  updateGoodsPrice,
  syncBatchPrice,
  updateItemRebateConf,
  getTagList,
  itemsRelTags,
  tagSearchItem,
  updateItemsStore,
  updateItemsStatus,
  updateItemsStockSyncStatus,
  getGoodsAttr,
  savebatchGoodsPricesApi,
  getDownloadList,
  deltags,
  correctionStore,
  getItemQRcode,
  getItemsAttrList,
  getItemsScopeList,
  setVipItmesPrice,
  goodsBatchShelfDownToUp,
  goodsBatchShelfUpToDown
} from '@/api/goods'
import {yibeiSync} from "@/api/sharer"

export default {
  components: {
    Treeselect,
    SideBar
  },
  props: ['getStatus'],
  provide() {
    return {
      refresh: this.getGoodsList
    }
  },
  data() {
    return {
      newimageurl:'',
      // 批量设置商品尊享会员折扣
      show_batch_vipdiscount: false,
      // 设置商品尊享会员折扣
      show_vipdiscount: false,
      // 当前选中商品ID
      current_item_id: 0,
      // 当前选中商品货号
      current_item_bn: '',
      // 当前选中商品会员折后价
      current_item_vip_price: 0,
      // 当前选中商品会员折扣
      current_item_vip_discount: 0,
      // 同步商品时是否允许设置库存（仅虚拟商品允许设置）
      show_item_stock: false,
      // 选择的商品个数
      goodsNum: 0,
      // 批量类型
      price_mode: 'formula',
      // 修改后的价格
      newPrice: '',
      // 算法
      newPrice2: '',
      // 大区调价
      // office_area_name:'',
      office_area_id: '',
      // office_area_all:{value:'0',name:'全平台'},
      new_office_area: [],
      office_area_param: {},
      search_item_bns: [],
      CategoryList: [],
      current_goods_price: 0,
      districtId: '0',
      stock: '',
      is_open: true,
      price_type_direct: [
        {value: 1, name: '商品价格'},
        {value: 2, name: '市场价'},
        {value: 3, name: '成本价'},
      ],
      price_type_formula: [
        {value: 1, name: '商品价格'},
        {value: 2, name: '市场价'},
        {value: 3, name: '成本价'},
      ],
      price_type_main: [
        {value: 1, name: '商品价格'},
        {value: 2, name: '市场价'},
        {value: 3, name: '成本价'},
      ],
      price_type_direct_sel: '',
      price_type_formula_sel: '',
      price_type_main_sel: '',
      algorithmVal: 1,
      algorithm: [{value: 1, name: '乘'},
        {value: 2, name: '除'},
        {value: 3, name: '加'},
        {value: 4, name: '减'},
      ],
      login_type: 'default',
      show_rebate_sideBar: false,
      select_regions_value: [],
      select_category_value: [],
      select_tags_value: [],
      select_branch_value: [],
      special_type_list: [
        {value: 'normal', name: '普通商品'},
        {value: 'drug', name: '处方药'},
      ],
      sku_list: [
        {value: 'false', name: '多规格统一展示'},
        {value: 'true', name: '多规格分开展示'},
      ],
      popularizeSetting: {
        popularize_ratio: {
          type: 'profit'
        }
      },
      regions: district,
      current: '',
      currentId: '',
      currentPrice: '',
      currentPriceChange: '',
      tabList: [
        {name: "全部商品", value: null, activeName: 'first'},
        // {name: "库存预警商品", value: 'true', activeName: 'second'},
      ],
      goodsName: '',
      isEdit: false,
      activeName: 'first',
      ItemsList: [],
      item_id: [],
      item_bn: [],
      goods_id: [],
      templates_id: '',
      templates_new_id: '',
      templatesList: [],
      category_id: [],
      categoryList: [],
      show_sideBar: false,
      loading: false,
      skuLoading: false,
      submitLoading: false,
      batchsubmitLoading: false,
      total_count: 0,
      warning_store: 5,
      templatesParams: {
        page: 1,
        pageSize: 1000,
      },
      goodsBranchList: [],
      goodsBranchParams: {
        page: 1,
        pageSize: 1000,
        attribute_type: 'brand',
        attribute_name: ''
      },
      tag: {
        dialog: false,
        dialogdel: false,
        editItem: [],
        list: [],
        form: {
          tag_ids: [],
          item_ids: []
        },
        currentTags: [],
        tags: []
      },
      params: {
        page: 1,
        pageSize: 20,
        item_type: 'normal',
        templates_id: '',
        keywords: '',
        category: 0,
        is_warning: false,
        tag_id: '',
        vip_flag: '',
      },
      start_date: '',
      end_date: '',
      addTemplatesdialogVisible: false,
      addCategorydialogVisible: false,
      currency: {},
      cursymbol: '￥',
      form: {},
      specItems: [],
      rebateSpecItems: [],
      grade: [],
      vipGrade: [],
      statusOption: [
        {title: '前台可销售', value: 'onsale'},
        {title: '可线下销售', value: 'offline_sale'},
        {title: '前台仅展示', value: 'only_show'},
        {title: '不可销售', value: 'instock'}
      ],
      shopStatusOption: [
        {title: '审核驳回', value: 'rejected'},
        {title: '等待审核', value: 'processing'},
        {title: '前台可销售', value: 'onsale'},
        {title: '可线下销售', value: 'offline_sale'},
        {title: '前台仅展示', value: 'only_show'},
        {title: '不可销售', value: 'instock'}
      ],
      storeUpdate: false,
      batchGoodsPricesView: false,
      storeItemsList: [],
      show_itemStore: false,
      updateBatchList: [],
      show_batchStore: false,
      show_batchPrice: false,
      shop_type_list: [],
      shop_type_list_default: [
        {shop_type_name: '未选择', shop_type_id: '-1'},
        {shop_type_name: '全部', shop_type_id: '0'},
        {shop_type_name: '怡康自营（药）店', shop_type_id: '-2'},
        {shop_type_name: '非怡康自营店', shop_type_id: '-3'}
      ],
      itemstore: 0,
      deltaglist: [],
      deltags: '',
      itemsAttrArr: [],
      itemsScopeArr: [],
    }
  },
  computed: {
    ...mapGetters([
      'wheight'
    ])
  },
  methods: {
    getItemsAttrLists() {
      getItemsAttrList().then(res => {
        this.itemsAttrArr = res.data.data
      })
    },
    getItemsScopeLists() {
      getItemsScopeList().then(res => {
        this.itemsScopeArr = res.data.data
      })
    },
    searchAction() {
      this.params.page = 1
      if (this.select_regions_value) {
        this.params.regions_id = this.select_regions_value
      }
      if (this.select_category_value) {
        for (var i in this.select_category_value) {
          this.params.category = this.select_category_value[i]
        }
      }
      if (this.select_tags_value) {
        this.params.tag_id = this.select_tags_value[0]
      }
      if (this.select_branch_value) {
        this.params.brand_id = this.select_branch_value[0]
      }
      if (this.search_item_bns) {
        this.params.item_bns = this.search_item_bns
      }

      this.getGoodsList()
    },
    changeHandler(value) {
      if (value == "formula") {
        this.price_type_direct_sel = '';
        this.newPrice = '';
      } else if (value == "direct") {
        this.price_type_formula_sel = '';
        this.price_type_main_sel = '';
        this.newPrice2 = '';
      } else {
        this.price_type_direct_sel = '';
        this.newPrice = '';
      }
    },
    price_type_direct_act(val) {

      if (this.price_mode == "formula") {
        this.price_type_direct_sel = '';
        this.newPrice = '';
        this.$message({
          type: 'error',
          message: '您已选择公式修改'
        })
      } else {
        this.price_type_direct_sel = val;
      }
    },
    price_type_formula_act(val) {

      if (this.price_mode == "direct") {
        this.price_type_formula_sel = '';
        this.price_type_main_sel = '';
        this.newPrice2 = '';
        this.$message({
          type: 'error',
          message: '您已选择直接修改'
        })
      } else {
        this.price_type_formula_sel = val;
      }
    },
    price_type_main_act(val) {

      if (this.price_mode == "direct") {
        this.price_type_formula_sel = '';
        this.price_type_main_sel = '';
        this.newPrice2 = '';
        this.$message({
          type: 'error',
          message: '您已选择直接修改'
        })
      } else {
        this.price_type_main_sel = val;
      }
    },
    algorithmVal_act(val) {
      this.algorithmVal = val;
    },
    onCopy() {
      this.$message({message: '复制成功', type: 'success'})
    },
    editPrice(id, price) {
      this.currentId = id
      this.currentPrice = price
      let self = this
      this.$nextTick(() => {
        self.$refs['input_' + id].focus()
      })
    },
    //删除商品付费价格
    editDelVipPrice(index, row) {
      this.$confirm('是否取消商品VIP价格', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then((res) => {
        let vipPrice = {
          // vip_price: row.market_price,
          vip_discount: 0, // 取消商品会员折扣
          item_id: row.itemId,
          del_flag: true
        }
        setVipItmesPrice(vipPrice).then(res => {
          this.$message({
            type: 'success',
            message: '操作成功'
          })
          this.getGoodsList()
        })
      }).catch(() => {
        this.$message({
          type: 'error',
          message: '取消操作'
        })
      })
    },
    showtitle(row){
      console.log('2222222222222222',row);
      this.newimageurl = row
    },
    // 设置默认付费会员价
    setDefaultVipPrice(index, row) {
      let vipPrice = {
        vip_price: row.market_price * 0.88,
        item_id: row.itemId
      }
      setVipItmesPrice(vipPrice).then(res => {
        this.$message({
          type: 'success',
          message: '操作成功'
        })
      })
      this.getGoodsList()
    },
    // 批量取消VIP商品折扣
    batchdelGoodsVipDiscount(data) {
      if (this.item_id.length == 0) {
        this.$message({
          type: 'error',
          message: '请选择至少一个商品!'
        })
        return false
      }
      this.$confirm('是否要批量取消商品会员折扣？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then((res) => {
        let vipPrice = {
          vip_discount: 0, // 取消商品会员折扣
          item_id: this.item_id,
          del_flag: true
        }
        const loading = this.$loading({
          lock: true,
          text: '提交中，请稍后',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        setVipItmesPrice(vipPrice).then(res => {
          this.$message({
            type: 'success',
            message: '操作成功'
          })
          loading.close()
          this.getGoodsList()
        })
      }).catch(() => {
        this.$message({
          type: 'error',
          message: '取消操作'
        })
      })
    },
    // 批量设置VIP商品折扣
    batchGoodsVipDiscount(data) {
      if (this.item_id.length == 0) {
        this.$message({
          type: 'error',
          message: '请选择至少一个商品!'
        })
      } else {
        this.show_rebate_sideBar = false
        this.show_batch_vipdiscount = true
      }
    },
    // 批量保存VIP商品折扣
    batchSaveVipDiscount() {
      let paramsArr = {}
      paramsArr = {
        'item_id': this.item_id,
        'vip_discount': this.current_item_vip_discount,
      }
      if (paramsArr.vip_discount >= 100 || paramsArr.vip_discount <= 0) {
        this.$message({message: '商品折扣异常，请核对后再试', type: 'error', duration: 3 * 1000})
        return false;
      }
      const loading = this.$loading({
        lock: true,
        text: '提交中，请稍后',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.submitLoading = true
      setVipItmesPrice(paramsArr).then(res => {
        if (res.data.data) {
          this.$message({
            type: 'success',
            message: '更新成功，请仔细核查前后端商品的会员价格'
          })
          loading.close()
          this.submitLoading = false
          this.show_batch_vipdiscount = false
          this.getGoodsList()
        } else {
          this.$message({
            type: 'error',
            message: '保存失败，请核对后再试'
          })
          loading.close()
          this.submitLoading = false
          this.show_batch_vipdiscount = false
        }
      })
    },
    // 设置VIP商品折扣
    handleVipDiscount(data) {
      if (!this.sku_disable()) {
        return false
      }
      this.show_rebate_sideBar = false
      this.show_vipdiscount = true
      this.current_item_id = data.item_id
      this.current_goods_price = data.price
      this.current_item_bn = data.item_bn
    },
    // 保存VIP商品折扣
    saveVipDiscount() {
      let paramsArr = {}
      paramsArr = {
        'item_id': this.current_item_id,
        'vip_discount': this.current_item_vip_discount,
        // 'vip_price': this.current_item_vip_price, // 价格计算全部放到后台
      }
      if (paramsArr.vip_discount >= 100 || paramsArr.vip_discount <= 0) {
        this.$message({message: '商品折扣异常，请核对后再试', type: 'error', duration: 3 * 1000})
        return false;
      }
      setVipItmesPrice(paramsArr).then(res => {
        if (res.data.data.vip_price) {
          this.$message({
            type: 'success',
            message: '更新成功，当前商品VIP价格是：' + (res.data.data.vip_price / 100)
          })
          this.getGoodsList()
        } else {
          this.$message({
            type: 'error',
            message: '保存失败，请核对后再试'
          })
        }
      })
      this.loading = false
      this.show_vipdiscount = false
    },
    // 修改付费会员价格
    editItemsVipPrice(index, row) {
      let vipPrice = {
        vip_price: row.vip_price * 100,
        item_id: row.itemId
      }
      setVipItmesPrice(vipPrice).then(res => {
        this.$message({
          type: 'success',
          message: '操作成功'
        })
      })
      this.getGoodsList()
    },
    savebatchGoodsPrices() {
      let paramsGoodsPrice = {};
      if (this.price_mode == 'direct') {
        paramsGoodsPrice = {
          item_id: this.item_id,
          type: this.price_mode,
          final_price: this.price_type_direct_sel,
          newPrice: this.newPrice
        };
      } else if (this.price_mode == 'formula') {
        paramsGoodsPrice = {
          item_id: this.item_id,
          type: this.price_mode,
          final_price: this.price_type_formula_sel,
          primary_price: this.price_type_main_sel,
          algorithm: this.algorithmVal,
          newPrice: this.newPrice2
        };
      }
      if (paramsGoodsPrice.newPrice != '') {
        this.$confirm('确定要修改当前价格，离开将丢失已编辑的数据？！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then((res) => {
          savebatchGoodsPricesApi(paramsGoodsPrice).then(res => {
            this.$message({
              type: 'success',
              message: '操作成功'
            })
            this.batchGoodsPricesView = false
            this.getGoodsList()
          })
        }).catch(() => {
          this.batchGoodsPricesView = false
          this.$message({
            type: 'error',
            message: '取消操作'
          })
        })
      } else {
        this.batchGoodsPricesView = false
        this.$message({
          type: 'error',
          message: '无操作'
        })
      }
    },
    handleBlur(index, scope) {
      if (this.currentPrice === this.ItemsList[index].price) {
        this.currentId = -1
        this.currentPrice = ''
        return
      }
      updateGoodsInfo({item_id: this.currentId, price: this.currentPrice}).then(res => {
        this.$message({
          type: 'success',
          message: '操作成功'
        })
        this.ItemsList[index].price = this.currentPrice
        scope.row.price = this.currentPrice
        this.currentId = -1
        this.currentPrice = ''
      })
    },
    handleClick(tab, event) {
      this.params.page = 1
      if (this.activeName == 'second') {
        this.params.is_warning = true
      } else {
        this.params.is_warning = false
      }
      this.getGoodsList()
    },
    setWarningStore() {
      getItemWarningStore({store: this.warning_store}).then(res => {
        this.params.page = 1
        this.getGoodsList()
      })
    },
    // 跳转到互动
    toActivity(activity) {
      // console.log(activity)
      if (activity.act_type == 'normal') {
        // 秒杀详情
        this.$router.push({path: '/marketing/marketingseckill/marketingseckill_editor?seckill_id=' + activity.act_id})
      } else if (activity.act_type == 'limited_time_sale') {
        // 限时特惠详情
        this.$router.push({path: '/marketing/limitedtimesale/limitedtimesale_editor/' + activity.act_id})
      } else if (activity.act_type == 'limit') {
        // 限购详情
        this.$router.push({path: '/marketing/goodslimit/goodslimit_editor/' + activity.act_id})
      } else if (activity.act_type == 'buy_gift') {
        // 买赠
        this.$router.push({path: '/marketing/buyonesfreeones/buyonesfreeones_editor/' + activity.act_id})
      } else {

      }
      this.$router.push({path: this.matchHidePage('editor/') + row.limit_id, query: {copy_flag: true}})
    },
    showQRWxapp(row) {
      getItemQRcode({item_bn: row.item_bn, item_id: row.item_id, type: 'wxapp'}).then(response => {
        var a = document.createElement('a')
        var temp = '商品码'
        a.href = response.data.data.qrcode_url
        if (response.data.data.tempname) {
          var temp = response.data.data.tempname
        }
        a.download = temp + '.png'
        a.click()
      })
    },
    handleCurrentChange(page_num) {
      this.params.page = page_num
      this.getGoodsList()
    },
    handleSizeChange(pageSize) {
      this.params.page = 1
      this.params.pageSize = pageSize
      this.getGoodsList()
    },
    handleChangeTemplates(val) {
      this.currentPage = 1
      this.params.templates_id = val
      this.getGoodsList()
    },
    handleSelectionChange(val) {
      let item_id = []
      for (let i in val) {
        item_id.push(val[i].itemId)
      }
      this.item_id = item_id
      let goods_id = []
      for (let i in val) {
        goods_id.push(val[i].goods_id)
      }
      this.goods_id = goods_id
      let item_bn = []
      for (let i in val) {
        item_bn.push(val[i].item_bn)
      }
      this.item_bn = item_bn
    },
    handleCancelLabelsDialog() {
      this.tag.dialog = false
    },

    tagUpdate(row) {
      if (!this.sku_disable()) {
        return false
      }
      this.tag.editItem = [row.itemName]
      this.tag.currentTags = row.tagList || []
      this.tag.form.item_ids = row.item_id
      this.showTags()
    },
    addItemTag() {
      this.tag.currentTags = []
      if (this.item_id.length) {

        this.tag.form.item_ids = this.item_id
        this.showTags()
      } else {
        this.$message({
          type: 'error',
          message: '请选择至少一个商品!'
        })
      }
    },
    handleCancelLabelsDialogdel() {
      this.tag.dialogdel = false
      this.deltaglist = this.tag.list
      console.log(this.tag.list)
    },
    //删除标签
    tagdelone(index) {
      this.deltags = '';
      this.deltags = this.tag.list[index].tag_id;
      this.deltaglist.splice(index, 1);
    },
    delItemTag() {
      if (this.item_id.length) {

        this.tag.dialogdel = true
        this.deltaglist = JSON.parse(JSON.stringify(this.tag.list));
      } else {
        this.$message({
          type: 'error',
          message: '请选择至少一个商品!'
        })
      }

    },
    submitItemTagdel() {
      this.tag.dialogdel = false
      //处理
      deltags({goods_id: this.goods_id, tag_id: this.deltags}).then(res => {
        if (res.data.status) {
          this.$message({
            type: 'success',
            message: '下标签完成'
          })
        } else {
          this.$message({
            type: 'error',
            message: '失败了'
          })
        }
      })
    },
    showTags() {
      // this.tag.tags = [...this.tag.list]
      this.tag.tags = []
      this.tag.list.forEach((item, index) => {
        let isInArr = this.tag.currentTags.findIndex((n) => n.tag_id == item.tag_id)
        if (isInArr == -1) this.tag.tags.push(item)
      })
      this.tag.dialog = true
    },
    tagRemove(index) {
      this.tag.tags.unshift(this.tag.currentTags[index])
      this.tag.currentTags.splice(index, 1)
    },
    tagAdd(item, index) {
      let isInArr = this.tag.currentTags.findIndex(n => n.tag_id == item.tag_id)
      if (isInArr == -1) {
        this.tag.currentTags.push(item)
        this.tag.tags.splice(index, 1)
      }
    },

    submitItemTag() {
      this.tag.form.tag_ids = []
      this.tag.currentTags.forEach(item => {
        this.tag.form.tag_ids.push(item.tag_id)
      })
      this.tag.dialog = false
      itemsRelTags(this.tag.form).then(res => {
        if (res.data.data.status) {
          this.$message({
            type: 'success',
            message: '打标签完成'
          })
        }
      })
    },
    tagSearchUserChange() {
      this.currentPage = 1
      this.getParams()
      this.getItemsList(this.params)
      this.loading = false
    },
    getAllTagLists() {
      let params = {
        page: 1,
        pageSize: 500
      }
      getTagList(params).then(response => {
        this.tag.list = response.data.data.list
      })
    },
    changeTemplates() {
      if (this.item_id.length) {
        if (!this.templates_new_id) {
          this.$message({
            type: 'error',
            message: '请选择运费模板'
          })
          return false
        }
        this.addTemplatesdialogVisible = false
        setItemsTemplate({"templates_id": this.templates_new_id, "item_id": this.item_id}).then(response => {
          this.getGoodsList()
        })
      } else {
        this.$message({
          type: 'error',
          message: '请选择至少一个商品'
        })
      }
    },
    editItemsSort(index, row) {
      setItemsSort({"sort": row.sort, "item_id": row.itemId}).then(response => {
        this.getGoodsList()
      })
    },
    changeCategory() {
      if (this.item_id.length) {
        if (!this.category_id) {
          this.$message({
            type: 'error',
            message: '请选择商品分类'
          })
          return false
        }
        this.addCategorydialogVisible = false
        setItemsCategory({"category_id": this.category_id, "item_id": this.item_id}).then(response => {
          this.getGoodsList()
          this.category_id = []
        })
      } else {
        this.$message({
          type: 'error',
          message: '请选择至少一个商品'
        })
      }
    },
    addItems() { // 添加商品
      this.$router.push({path: this.matchHidePage('editor')})
    },
    addTemplates() {
      if (this.item_id.length) {
        this.addTemplatesdialogVisible = true
      } else {
        this.$message({
          type: 'error',
          message: '请选择至少一个商品'
        })
      }
    },
    addCategory() {
      if (this.item_id.length) {
        this.addCategorydialogVisible = true
      } else {
        this.$message({
          type: 'error',
          message: '请选择至少一个商品'
        })
      }
    },
    editItemsAction(index, row, isNew) { // 编辑商品弹框
      if (!this.sku_disable()) {
        return false;
      }
      if (isNew) {
        var routeData = this.$router.push({path: this.matchHidePage('editor/') + row.itemId, query: {is_new: true}});
      } else {
        var routeData = this.$router.push({path: this.matchHidePage('editor/') + row.itemId});
      }
    },
    sku_disable() {
      if (this.params.is_sku == "true") {
        this.$message({message: '多规格分裂展示不可编辑商品', type: 'error', duration: 2 * 1000})
        return false;
      } else {
        return true;
      }
    },
    saveRebateConf() {
      var rebateConf = []
      this.rebateSpecItems.forEach(item => {
        var rebate_conf = item.rebate_conf
        rebate_conf.ratio_type = this.popularizeSetting.popularize_ratio.type
        rebateConf.push(rebate_conf)
      })
      updateItemRebateConf({rebateConf: JSON.stringify(rebateConf)}).then(res => {
        this.$message({message: '保存成功', type: 'success', duration: 2 * 1000})
      })
    },
    handleRebateConf(data) {
      this.show_rebate_sideBar = true
      this.show_sideBar = false
      this.skuLoading = true
      this.current = data
      getItemsList({page: 1, pageSize: 1000, is_sku: true, item_id: data.item_id, item_type: 'normal'}).then(res => {
        var rebateSpecItems = []
        res.data.data.list.forEach(item => {
          if (item.rebate_conf.length === 0) {
            item.rebate_conf = {}
            item.rebate_conf.type = 'money'
            item.rebate_conf.value = {}
            for (var key in this.popularizeSetting.popularize_ratio.profit) {
              item.rebate_conf.value[key] = ''
            }
          } else {
            if (this.popularizeSetting.popularize_ratio.type != item.rebate_conf.ratio_type && item.rebate_conf.type != 'money') {
              for (var key in this.popularizeSetting.popularize_ratio.profit) {
                item.rebate_conf.value[key] = ''
              }
            }
          }
          item.rebate_conf.item_id = item.item_id
          rebateSpecItems.push(item)
        })
        this.rebateSpecItems = rebateSpecItems
        this.skuLoading = false
      })
    },
    handlePrice(data) {
      if (!this.sku_disable()) {
        return false
      }
      this.show_rebate_sideBar = false
      this.show_sideBar = true
      this.current = data.item_id
      this.getGoodsPrice(data.item_id)
    },
    handleBatchStore(data) {
      if (!this.sku_disable()) {
        return false
      }
      this.show_rebate_sideBar = false
      this.show_item_stock = isNaN(data.item_bn)
      // this.show_sideBar = true
      this.show_batchStore = true
      this.current = data.item_id
      this.current_goods_price = data.price
      this.getBatchData(data.item_id)
    },
    CorrectionNPStore(data) {
      if (!this.sku_disable()) {
        return false
      }
      var query = {
        "item_bn": data.item_bn
      }
      correctionStore(query).then(response => {
        this.$message({
          type: 'success',
          message: '校正开始，请稍后查看...'
        })
      }).catch(error => {
        this.$message({
          type: 'error',
          message: 'NP库存校正失败'
        })
      })
    },
    handleBatchPrice(data) {
      this.show_rebate_sideBar = false
      // this.show_sideBar = true
      this.show_batchPirce = true
      this.current = data.item_id
    },
    getOfficeArea() {
      getAreaManageList({'format_flag': true}).then(response => {
        this.params.page = 1;
        this.new_office_area = response.data.data;
      })

    },
    handleOfficeChange: function (val) {
      // console.log(this.office_area_name)
      // var now_office_area_name = this.office_area_name
      // var now_office_area_id = '0'
      //
      // office_area.map(function(value,index,array){
      //     if(value.name === now_office_area_name){
      //         now_office_area_id = value.area_id
      //     }
      // })
      //
      // this.office_area_id = now_office_area_id
      // console.log(now_office_area_id)
      // this.params.office_area_id = this.office_area_id
      //分离出区域id 和区域父id
      var now_office_area_pid = val[0]
      if (val.length > 1) {
        var now_office_area_id = val[1]
      } else {
        var now_office_area_id = 0
      }
      this.office_area_id = now_office_area_id
      this.office_area_pid = now_office_area_pid
    },
    batchShelfUpToDown() {
      this.$confirm('此操作会将已上架的商品下架, 是否继续?', '上架->下架', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (this.item_id.length <= 0) {
          this.$message({type: 'error', message: '请至少选择一个商品'})
        }
        goodsBatchShelfUpToDown({item_ids:this.item_id}).then(response => {
          if (response.data.data.status === true) {
            this.$message({type: 'success', message: response.data.data.msg})
            this.params.page = 1
            this.getGoodsList()
          } else {
            this.$message({type: 'error', message: response.data.data.msg})
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    batchShelfDownToUp() {
      this.$confirm('此操作会将已下架的商品上架, 是否继续?', '下架->上架', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (this.item_id.length <= 0) {
          this.$message({type: 'error', message: '请至少选择一个商品'})
        }
        goodsBatchShelfDownToUp({item_ids:this.item_id}).then(response => {
          if (response.data.data.status === true) {
            console.log(response)
            this.$message({type: 'success', message: response.data.data.msg})
            this.params.page = 1
            this.getGoodsList()
          } else {
            this.$message({type: 'error', message: response.data.data.msg})
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    getBatchData(item_id) {
      this.skuLoading = true
      this.updateBatchList[''] = '';
      getShopTypes().then(res => {
        this.shop_type_list = res.data.data.list
      })
      this.skuLoading = false
    },
    getGoodsPrice(item_id) {
      this.skuLoading = true
      getGoodsPrice(item_id).then(res => {
        let specItems = []
        let colConfigs = []
        res.data.data.list.forEach(item => {
          specItems.push({
            item_id: item.item_id,
            item_spec_desc: item.item_spec_desc || item.itemName,
            price: item.price / 100,
            grade: this.generatePrice(item.memberGrade.grade),
            vipGrade: this.generatePrice(item.memberGrade.vipGrade),
            distributors_prices_arr: item.distributors_prices_arr,
          })
        })
        this.grade = this.generatePrice(res.data.data.list[0].memberGrade.grade)
        this.vipGrade = this.generatePrice(res.data.data.list[0].memberGrade.vipGrade)
        this.specItems = specItems
        this.skuLoading = false
      })
    },
    generatePrice(data) {
      let list = []
      for (let key in data) {
        list.push({
          vip_grade_id: data[key].vip_grade_id,
          grade_name: data[key].grade_name,
          mprice: data[key].mprice / 100 || '',
        })
      }
      return list
    },
    syncPrice(item_id) {
      // 同步商品价格 暂时不考虑多规格价格
      // 增加大区id
      var now_office_area_id = this.office_area_id
      var now_office_area_pid = this.office_area_pid
      // var now_office_area_name = this.office_area_name
      var price = this.currentPriceChange
      let param = {
        item_id: item_id,
        price: price,
        now_office_area_id: now_office_area_id,
        now_office_area_pid: now_office_area_pid,
        distributor_number: this.districtId,
      }
      this.batchsubmitLoading = true

      const _self = this
      console.log(this.specItems)
      if (this.specItems.length > 1) {
        this.$message({
          type: 'error',
          message: '多规格商品暂不支持批量同步价格',
          duration: 1500,
          onClose() {
            _self.batchsubmitLoading = false
          }
        })
        return false;
      }
      // this.specItems.forEach(item => {
      //     let grade = {}
      //     item.grade.forEach(child => {
      //         Object.assign(grade, {[child.vip_grade_id]: child.mprice})
      //     })
      //     let vipGrade = {}
      //     item.vipGrade.forEach(child => {
      //         Object.assign(vipGrade, {[child.vip_grade_id]: child.mprice})
      //     })
      //     Object.assign(skus, {[item.item_id]: {
      //             grade: grade,
      //             vipGrade: vipGrade
      //         }})
      // })

      syncBatchPrice(param).then(res => {
        if (res.data.data.status === true) {
          this.$message({
            type: 'success',
            message: '更新成功同步了' + res.data.data.number + '店铺',
            duration: 2000,
            onClose() {
              _self.batchsubmitLoading = false
              _self.currentPriceChange = ''
            }
          })
        } else {
          this.$message({
            type: 'error',
            message: '更新失败',
            duration: 2000,
            onClose() {
              _self.batchsubmitLoading = false
            }
          })
        }
        // 刷新页面
        this.getGoodsList()
      }).catch(res => {
        console.log("errr")
        this.batchsubmitLoading = false
      })
    },
    savePrice() {
      let param = {
        item_id: this.current,
        mprice: ''
      }
      let skus = {}
      this.specItems.forEach(item => {
        let grade = {}
        item.grade.forEach(child => {
          Object.assign(grade, {[child.vip_grade_id]: child.mprice})
        })
        let vipGrade = {}
        item.vipGrade.forEach(child => {
          Object.assign(vipGrade, {[child.vip_grade_id]: child.mprice})
        })
        Object.assign(skus, {
          [item.item_id]: {
            grade: grade,
            vipGrade: vipGrade
          }
        })
      })
      param.mprice = JSON.stringify(skus)

      this.submitLoading = true
      const _self = this
      updateGoodsPrice(param).then(res => {
        this.$message({
          type: 'success',
          message: '更新成功',
          duration: 2000,
          onClose() {
            _self.submitLoading = false
            _self.getGoodsPrice(param.item_id)
          }
        })
      }).catch(res => {
        _self.submitLoading = false
      })
    },
    goodsSearch() {
      this.params.page = 1
      this.getGoodsList()
    },
    getGoodsList() {
      this.loading = true
      getItemsList(this.params).then(response => {
        this.ItemsList = response.data.data.list
        this.ItemsList.forEach(item => {
          item.price = item.price / 100
          item.vip_price = item.vip_price / 100
          item.link = `pages/item/espier-detail?gid=${item.goods_id}&id=${item.item_id}`
        })
        this.total_count = response.data.data.total_count
        this.warning_store = response.data.data.warning_store
        this.loading = false
      })
    },
    deleteItemsAction(index, row) {
      if (!this.sku_disable()) {
        return false;
      }
      this.$confirm('此操作将删除该商品, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteItems(row.itemId).then(response => {
          this.ItemsList.splice(index, 1)
          this.$message({
            message: '删除商品成功',
            type: 'success',
            duration: 2 * 1000
          })
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    priceformatter(row, column) {
      return this.cursymbol + row.price / 100;
    },
    rebateformatter(row, column) {
      return this.cursymbol + row.rebate / 100;
    },
    getTaskTime(strDate) {
      let date = new Date(strDate)
      let y = date.getFullYear()
      let m = date.getMonth() + 1
      m = m < 10 ? ('0' + m) : m
      let d = date.getDate()
      d = d < 10 ? ('0' + d) : d
      let str = y + "-" + m + "-" + d
      return str
    },
    getTimeStr(date) {
      return this.getTaskTime(new Date(parseInt(date) * 1000))
    },
    getShippingTemplatesList() {
      this.loading = true
      getShippingTemplatesList(this.templatesParams).then(response => {
        this.templatesList = response.data.data.list
      })
    },
    getGoodsBranchList() {
      this.loading = true
      getGoodsAttr(this.goodsBranchParams).then(response => {
        this.goodsBranchList = response.data.data.list
      })
    },
    getCategory() {
      getCategory({is_show: false}).then(response => {
        this.categoryList = response.data.data
      })
    },
    getCurrencyInfo() {
      getDefaultCurrency().then(res => {
        this.currency = res.data.data
        this.cursymbol = this.currency.symbol
      })
    },
    batchItemsStore() {
      this.storeItemsList = []
      if (this.item_id.length) {
        this.storeUpdate = true
      } else {
        this.$message({
          type: 'error',
          message: '请选择至少一个商品'
        })
      }
    },
    batchGoodsPrices() {
      this.storeItemsList = []
      if (this.item_id.length) {
        this.goodsNum = this.item_id.length
        this.batchGoodsPricesView = true
      } else {
        this.$message({
          type: 'error',
          message: '请选择至少一个商品'
        })
      }
    },
    batchItemsStatus(status) {
      if (this.goods_id.length === 0) {
        this.$message({
          type: 'error',
          message: '请选择至少一个商品'
        })
        return false
      }
      this.skuLoading = true
      let params = {}
      if (this.goods_id.length > 0) {
        let data = []
        this.goods_id.forEach(goods_id => {
          data.push({goods_id: goods_id})
        })
        params = {
          'items': JSON.stringify(data),
          'status': status
        }
      }
      this.submitLoading = true
      updateItemsStatus(params).then(res => {
        if (res.data.data.status) {
          this.$message({
            message: '修改成功',
            type: 'success',
            duration: 2 * 1000
          })
          this.getGoodsList()
        }
        this.submitLoading = false
        this.skuLoading = false
      })
    },
    updateItemStatus(items) {
      if (!this.sku_disable()) {
        return false
      }
      this.loading = true
      let params = {}
      params = {
        'items': [{"goods_id": items.goods_id}],
        'status': items.approve_status === 'instock' ? 'onsale' : 'instock'
      }
      updateItemsStatus(params).then(res => {
        if (res.data.data.status) {
          this.$message({
            message: '操作成功',
            type: 'success',
            duration: 2 * 1000
          })
          this.getGoodsList()
        }
      })
      this.loading = false
    },
    updateItemStockSyncStatus(items) {
      if (!this.sku_disable()) {
        return false
      }
      this.loading = true
      let params = {}
      params = {
        'items': [{"goods_id": items.goods_id}],
        'status': items.stock_sync_status === true ? 0 : 1
      }
      updateItemsStockSyncStatus(params).then(res => {
        if (res.data.data.status) {
          this.$message({
            message: '操作成功',
            type: 'success',
            duration: 2 * 1000
          })
          this.getGoodsList()
        }
      })
      this.loading = false
    },
    dragIssuesOptions: {
          animation: 300,
          forceFallback: true,
          scroll: true,
          handle: '.icon-arrows-alt',
          draggable: '.goodspic'
    },
    updateItemsStore(items) {
      if (!this.sku_disable()) {
        return false
      }
      this.skuLoading = true
      this.item_id = []
      let param = JSON.parse(JSON.stringify(this.params))
      param.item_id = items.item_id
      param.is_sku = true
      this.storeItemsList = []
      getItemsList(param).then(response => {
        let list = response.data.data.list
        let data = {}
        list.forEach(item => {
          let data = {
            item_id: item.item_id,
            store: item.store,
            item_spec_desc: item.item_spec_desc ? item.item_spec_desc : item.item_name
          }
          this.storeItemsList.push(data)
        })
        this.skuLoading = false
      })
      this.show_itemStore = true
    },
    saveSynsc() {
      let paramsArr = {}
      paramsArr = {
        'store': this.stock,
        'distributor_number': this.districtId,
        'shop_type_id': this.params.shop_type_id,
        'item_id': this.current,
        'can_sale': this.is_open,
        'office_area_id': this.office_area_id,
        'office_area_pid': this.office_area_pid,
      }
      // 店铺类型和区域只能选中一个
      if (this.params.shop_type_id != -1 && this.office_area_pid) {
        alert('店铺类型和区域只能选中一个!');
        return false;
      }
      if (this.params.shop_type_id == -1 && !this.office_area_pid && this.districtId == 0) {
        alert('请选择店铺!');
        return false;
      }
      addStore(paramsArr).then(response => {
        let status = response.data.data.status
        var messInfo = status ? '正在同步中...' : '操作失败';
        var typeMes = status ? 'success' : 'error';
        this.$message({
          type: typeMes,
          message: messInfo
        });
      })
    },
    saveItemsStore() {
      this.skuLoading = true
      let params = {}
      if (this.storeItemsList.length > 0) {
        params = {
          'items': JSON.stringify(this.storeItemsList)
        }
      } else if (this.item_id.length > 0) {
        let data = []
        this.item_id.forEach(itemid => {
          data.push({item_id: itemid, store: this.itemstore, is_default: true})
        })
        params = {
          'items': JSON.stringify(data)
        }
      }
      this.submitLoading = true
      const _self = this
      updateItemsStore(params).then(res => {
        if (res.data.data.status) {
          this.$message({
            message: '修改成功',
            type: 'success',
            duration: 2 * 1000
          })
        }
        this.submitLoading = false
        this.skuLoading = false
        this.storeUpdate = false
      })
    },
    // 商品同步怡贝
    yibeiSync(items) {
      let params = {}
      params = {
        'items': [{"item_id": items.item_id}]
      }
      yibeiSync(params).then(res => {
        if (res.data.data.status) {
          this.$message({
            message: '同步怡贝成功',
            type: 'success',
            duration: 2 * 1000
          })
        }
      })
    },
    // 商品批量同步怡贝
    batchYibeiSync() {
      if (this.item_id.length === 0) {
        this.$message({
          type: 'error',
          message: '请选择至少一个商品'
        })
        return false
      }
      this.skuLoading = true
      let params = {}
      if (this.item_id.length > 0) {
        let data = []
        this.item_id.forEach(item_id => {
          data.push({item_id: item_id})
        })
        params = {
          'items': JSON.stringify(data)
        }
      }
      yibeiSync(params).then(res => {
        if (res.data.data.status) {
          this.$message({
            message: '批量同步怡贝成功',
            type: 'success',
            duration: 2 * 1000
          })
          this.getGoodsList()
        }
      })
    },
    // 批量导出数据
    download() {
      this.params.is_sku = true;
      this.params.item_type = 'normal';
      getDownloadList(this.params).then(res => {
        if (res.data.status) {
          this.$message({
            message: '已添加到队列',
            type: 'success',
            duration: 2 * 1000
          })
        }
      })
    }
  },
  mounted() {
    this.login_type = this.$store.getters.login_type
    if (this.$route.query.category) {
      this.params.category = this.$route.query.category
    }
    this.params.main_cat_id = this.$route.query.main_cat_id
    if (this.$route.query.approve_status) {
      this.params.approve_status = this.$route.query.approve_status
    }
    getPopularizeSetting().then(response => {
      this.popularizeSetting = response.data.data
    })
    if (this.$route.query.tab) {
      this.activeName = this.$route.query.tab
      this.params.is_warning = true
    }
    this.getOfficeArea()
    this.getGoodsList()
    this.getShippingTemplatesList()
    this.getCategory()
    this.getCurrencyInfo()
    this.getAllTagLists()
    this.getGoodsBranchList()
    this.getItemsAttrLists()
    this.getItemsScopeLists()
  },
  watch: {
    getStatus(val) {
      if (val) {
        this.getGoodsList()
      }
    }
  }
}
</script>
<style scoped lang="scss">
.el-row {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }

  img {
    width: 90%;
  }
}

.el-col {
  border-radius: 4px;
}

.bg-purple-dark {
  background: #99a9bf;
}

.bg-purple {
  background: #d3dce6;
}

.bg-purple-light {
  background: #e5e9f2;
}

.grid-content {
  border-radius: 4px;
  min-height: 10px;

  img {
    width: 90%;
  }
}

.row-bg {
  padding: 10px 20px;
  background-color: #f9fafc;
}

.service-label .el-checkbox:first-child {
  margin-left: 15px;
}

.service-label .el-input:first-child {
  margin-left: 15px;
}

.grid-detail {
  max-height: 300px;
  overflow-y: scroll;
  margin-bottom: 20px;
}

.el-carousel {
  width: 375px;
}

.tag-users {
  padding-bottom: 10px;
  line-height: 1.2;

  .icon-user-circle1 {
    margin-right: 10px;
    font-size: 24px;
    color: #ccc;
  }
}

.selected-tags {
  padding-top: 15px;
  margin-bottom: 15px;
  border-top: 1px solid #efefef;
  border-bottom: 1px solid #efefef;

  .label {
    margin-bottom: 15px;
  }

  .el-tag {
    margin-right: 10px;
    margin-bottom: 15px;
  }
}

.tag-item {
  cursor: pointer;
  color: #666;
  border-color: #dadadd;
  margin-right: 10px;
  margin-top: 10px;
}

.copy-btn {
  position: relative;

  [class^="copy-link"] {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    visibility: hidden;
  }
}
</style>
<style lang="scss">
.grid-detail {
  table, .detail-content-wrap, .detail-content-item {
    width: 100% !important;
  }

  img {
    width: 100%;
  }
}
.grid-attribute {
  table {
    width: 100% !important;
  }
}

.batch_price .el-col {
  padding-left: 5px;
  padding-right: 5px;
  display: flex;
  justify-content: center;
  align-items: center;

}

.pri-inp .el-input__inner {
  padding: 1.18rem;
  height: 28px;
  line-height: 28px;
  width: 9rem;
}

.pri-tag {
  magin: 0 8rem;
  width: 3rem;
}

span.price-content {
  display: flex;
  margin-left: 2rem;
  line-height: 1.5rem;
  color: #101010;
}
.goodspic-wrap {
  float: left;
  margin-right: 5px;
  overflow: hidden;
  .goodspic {
    position: relative;
    float: left;
    width: 120px;
    height: 120px;
    margin: 0 5px 10px;
    border: 1px solid #ddd;
    border-radius: 8px;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
    }
    .goodspic-mask {
      display: none;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 2;
      width: 100%;
      height: 100%;
      background: rgba(0,0,0,.2);
      cursor: pointer;
      &.on {
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .iconfont {
        margin: 0 8px;
        font-size: 20px;
        color: #fff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// imagelist.vue?efe302aa